import { useContext, useMemo, useState } from 'react';
import { Badge, Box, Fab } from '@mui/material';
import { ShoppingCart } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { encryptURL } from 'utils/functions';
import { VendaExternaContext } from 'contexts/VendaExternaContext';
import { GridContext } from 'contexts/GridContext';
import { useModal, useDialog } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import DataView, { useDataViewFilters } from 'components/DataView';
import CarrinhoModal from './Modals/CarrinhoModal';
import columnOverrides from './columnOverrides';
import getVendaExternaItensFilterFields from './filterFields';

const VendaExternaItens = () => {
  const rotina = 'RemessasVendaExternaItens';
  const titulo = 'Itens de Vendas Externas (Fora do Estabelecimento)';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [itens, setItens] = useState([]);
  const { openModal, closeModal } = useModal();
  const { openDialog, closeDialog } = useDialog();
  const { exportPdf, exportXls } = useContext(GridContext);
  const { vendaExternaItens, getVendaExternaItens, getLoading } =
    useContext(VendaExternaContext);

  const filterFields = useMemo(() => getVendaExternaItensFilterFields(), []);

  const { applyFilter, filterForm } = useDataViewFilters({
    fields: filterFields,
    searchParams,
    setSearchParams,
    onApply: (props) => loadGrid(props),
  });
  const { getValues } = filterForm;

  const loadGrid = (props = {}) => {
    const filter = props?.filter || getValues();

    closeModal();
    closeDialog();

    getVendaExternaItens({ ...props, rotina, filter });
  };

  const toolbarActions = [
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({
          rotina,
          filter: getValues(),
          order: vendaExternaItens?.order,
        }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({
          rotina,
          filter: getValues(),
          order: vendaExternaItens?.order,
        }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={vendaExternaItens?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
    // {
    //   name: 'Consignar',
    //   icon: 'change_circle',
    //   action: (selected) => {
    //     const itens = selected?.map((s) => ({
    //       ...s,
    //       quantidade_max: s?.quantidade,
    //       preco_max: s?.preco,
    //       subtotal:
    //         (s?.quantidade || 0) * (s?.preco || 0) + (s?.desconto_vlr || 0),
    //     }));
    //     navigate(`/app/Remessas/Consignar`, {
    //       state: { itens, vendedor_id: user?.entidade_id },
    //     });
    //   },
    // },
    // {
    //   name: 'Vender',
    //   icon: 'monetization_on',
    //   action: (selected) => {
    //     const itens = selected?.map((s) => s?.id);
    //     const hash = encryptURL({ itens });
    //     navigate(`/app/Remessas/Venda/${hash}`);
    //   },
    // },
  ];

  const rowActions = [
    {
      name: 'Resumo da Remessa',
      icon: 'summarize',
      menu: true,
      action: ({ row }) =>
        navigate(`/app/Remessas/Resumo/${row?.documento_id}`),
    },
    {
      name: 'Vender',
      icon: 'shopping_cart',
      show: ({ row }) => !itens?.some((s) => s?.id === row?.id),
      action: ({ row }) => setItens((prev) => [...prev, row]),
    },
    {
      name: 'Retornar Remessa',
      icon: 'undo',
      menu: true,
      action: ({ row }) =>
        navigate(`/app/Remessas/Retorno/${row?.documento_id}`),
    },
  ];

  return (
    <Container fillHeight>
      <Header
        titulo={titulo}
        rotina={rotina}
        colunas={vendaExternaItens?.colunas}
      />
      <Card fillHeight>
        <DataView
          fillHeight
          grid={vendaExternaItens}
          filterFields={filterFields}
          filterForm={filterForm}
          onFilter={applyFilter}
          columnOverrides={columnOverrides}
          toolbarActions={toolbarActions}
          rowActions={rowActions}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
        />
      </Card>
      <Box sx={{ position: 'fixed', bottom: 100, right: 55 }}>
        <Badge
          badgeContent={itens?.length}
          color="secondary"
          max={99}
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Fab
            color="primary"
            onClick={() =>
              openDialog(
                <CarrinhoModal
                  itens={itens}
                  setItens={setItens}
                  onSubmit={(arr) => {
                    const hash = encryptURL({ itens: arr?.map((s) => s?.id) });
                    closeDialog();
                    navigate(`/app/Remessas/Venda/${hash}`);
                  }}
                />,
                'Itens adicionados ao carrinho'
              )
            }
            sx={{ zIndex: 1 }}
          >
            <ShoppingCart />
          </Fab>
        </Badge>
      </Box>
    </Container>
  );
};

export default VendaExternaItens;
